// olap-client/src/components/chat/LeftSidebar.jsx
import React, { useContext } from 'react';
import { observer } from 'mobx-react-lite';
import { Context } from '../..';

const LeftSidebar = observer(() => {
  const { chat } = useContext(Context);

  return (
    <div style={{
      width: '70px',
      background: '#f4f4f5',
      borderRight: '1px solid #e4e4e5',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      padding: '10px 0',
      gap: '20px'
    }}>
      {/* Бургер меню */}
      <IconButton
        icon="☰"
        title="Меню"
        onClick={() => chat.toggleLeftSidebar()}
      />

      {/* Группы чатов (заглушки) */}
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '15px',
        flex: 1
      }}>
        <IconButton
          icon="💬"
          label="Все"
          title="Все чаты"
          onClick={() => console.log('Все чаты')}
        />
        <IconButton
          icon="⭐"
          label="Избранное"
          title="Избранные чаты"
          onClick={() => console.log('Избранное')}
        />
        <IconButton
          icon="👥"
          label="Группы"
          title="Групповые чаты"
          onClick={() => console.log('Группы')}
        />
        <IconButton
          icon="🔒"
          label="Личные"
          title="Личные чаты"
          onClick={() => console.log('Личные')}
        />
      </div>

      {/* Настройки групп (заглушка) */}
      <IconButton
        icon="⚙️"
        title="Настройки групп"
        onClick={() => console.log('Настройки групп')}
      />
    </div>
  );
});

// Компонент иконки с подписью
const IconButton = ({ icon, label, title, onClick }) => (
  <div
    onClick={onClick}
    title={title}
    style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: '4px',
      cursor: 'pointer',
      padding: '8px',
      borderRadius: '8px',
      transition: 'background 0.2s',
      width: '60px'
    }}
    onMouseEnter={(e) => e.currentTarget.style.background = '#e4e4e5'}
    onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
  >
    <span style={{ fontSize: '24px' }}>{icon}</span>
    {label && (
      <span style={{
        fontSize: '10px',
        color: '#707579',
        textAlign: 'center',
        lineHeight: '1.2'
      }}>
        {label}
      </span>
    )}
  </div>
);

export default LeftSidebar;